<template>
  <div class="container">
    <div id="MovieKids">
      <h1 class="title">Kids</h1>
    </div>

    <h3 class="linea">Movies</h3>

    <ith-grid-movies-kids-detail />
    <ith-pagination-bullets />

    <div id="SerieKids"></div>
    <div>
      <h3 class="linea">Tv Shows</h3>
    </div>

    <ith-grid-series-kids-detail />
    <ith-pagination-bullets />
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
#MovieKids {
  padding-top: 0px;
}
#SerieKids {
  padding-top: 35px;
}
.title {
  font-size: 35px;
  font-weight: 600;
}

h3 {
  font-weight: 400;
  margin-top: 35px;
}
h3.linea {
  position: relative;
  z-index: 1;
}
h3.linea:before {
  border-top: 1px solid #738092;
  content: "";
  margin: 0 auto;
  position: absolute;
  top: 55%;
  left: 8%;
  right: 0;
  bottom: 0;
  width: 92%;
  z-index: -1;
}
h3.linea span {
  z-index: 100;
  color: #738092;
  background: #fff;
  padding: 10px 15px;
}
.container {
  min-height: 1210px;
}

@media (min-width: 1400px) {
}
@media (min-width: 1264px) and (max-width: 1400px) {
}
@media (min-width: 1020px) and (max-width: 1264px) {
  .title {
    margin: 0px 10px;
  }
}
@media (min-width: 960px) and (max-width: 1020px) {
}
@media (min-width: 600px) and (max-width: 960px) {
  .title {
    margin: 0px 10px;
    padding-top: 0px;
    font-size: 20px;
  }
  .linea {
    margin: 15px 15px;
    font-size: 18px;
  }
  h3.linea:before {
    width: 80%;
    left: 10%;
  }
}

@media (max-width: 600px) {
  .container {
    min-height: 1210px;
  }
  .title {
    margin: 0px 10px;
    padding-top: 0px;
    font-size: 20px;
  }
  .linea {
    margin: 15px 15px;
    font-size: 18px;
  }
  h3.linea:before {
    width: 70%;
    left: 25%;
  }
}
</style>
